// import { toast } from 'react-toastify';
import { Types } from '../reducers/domains';
import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import errorMessages from 'utils/consts/errors';

// Asynchronous

// Synchronous
export const createDomain = (domainData, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.post(serverRoutes.Domains.item(), domainData)
      .then((response) => {
        dispatch({
          type: Types.CREATE_DOMAINS,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
        console.log(err, err?.response?.data)
      })
  }
}

export const getDomains = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Domains.item(''), { params: { page, limit, query, sort } })
      .then((response) => {
        dispatch({
          type: Types.GET_PAGED_DOMAINS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_PAGED_DOMAINS,
          payload: []
        });
      })
  }
}

export const getAllDomains = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Domains.getAll)
      .then((response) => {
        dispatch({
          type: Types.GET_DOMAINS,
          payload: response.data
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_DOMAINS,
          payload: []
        });
      })
  }
}

export const getDomain = (domainname) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING
    });
    axiosInstanceV2.get(serverRoutes.Domains.profile(`/${domainname}`))
      .then((response) => {
        dispatch({
          type: Types.GET_DOMAIN,
          payload: response.data
        })
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: Types.GET_DOMAIN,
          payload: null,
        })
      })
  }
}

export const updateDomain = (domainId, domainData, callback) => {
  return (dispatch) => {
    axiosInstanceV2.put(serverRoutes.Domains.profile(`/${domainId}`), domainData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_DOMAIN,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.message || err.response?.data || err.request?.responseText) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
        console.log(err, err?.response?.data)
      });
  }
}

export const deleteDomain = (domainId, callback) => {
  return (dispatch) => {
    axiosInstanceV2.delete(serverRoutes.Domains.item(`/${domainId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_DOMAIN,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err)
        callback(false);
      })
  }
}
